angular.module('tcApp')
.service('GraphService', function($window, $sce, TimelineService, OverlayService) {
	var d3 = $window.window.d3;
	var svgNS = 'http://www.w3.org/2000/svg';
	
	var itemTypeLine = 'line';
	var itemTypeFluidBalance = 'fluidBalance';
	var itemTypeRX = 'RX';

	var dimensions = {
		selectionBorderThickness: 3, // thickness of border around popover selection
		size: 40 // pixels, Touch target size
	};
	
	
	// Returns html id for Graph axis units group
	var getAxisUnitsGroupId = function(htmlIdPrefix, index) {
		return htmlIdPrefix + '-axisUnits_' + index;
	};
	
	// Returns html id for Graph item units group
	var getItemUnitsGroupId = function(htmlIdPrefix, item) {
		return htmlIdPrefix + '-itemUnits_' + item.htmlId;
	};
	
	// Returns html id for Graph item order group
	var getItemOrderGroupId = function(htmlIdPrefix, order) {
		return htmlIdPrefix + '-orderGroup_' + order.htmlId;
	};
	
	// Returns html id for Graph item markers
	var getMarkerId = function(htmlIdPrefix, marker) {
		return htmlIdPrefix + '-marker_' + marker.htmlId;
	};
	
	// Return id for <g> element that contains svg for graph Item Out of Range Data
	var getGraphItemOutOfRangeGroupId = function(htmlIdPrefix, graphDataItem) {
		return htmlIdPrefix + '-itemOutOfRangeGroup_' + graphDataItem.htmlId;
	};
	
	// Return id for <g> element that contains svg for graph Item Reference Lines
	var getGraphItemRefRangeGroupId = function(htmlIdPrefix, graphDataItem) {
		return htmlIdPrefix + '-itemRefRangeGroup_' + graphDataItem.htmlId; 
	};
	
	// Return id for <g> element that contains svg for graph Item Non Linear Reference Lines
	var getGraphItemNonLinearRefRangeGroupId = function(htmlIdPrefix, graphDataItem) {
		return htmlIdPrefix + '-itemNonLinearRefRangeGroup_' + graphDataItem.htmlId;	
	};
	
	// Return id for <g> element that contains svg for graph Item EWS Ranges
	var getGraphItemEWSRangesGroupId = function(htmlIdPrefix, graphDataItem) {
		return htmlIdPrefix + '-itemEWSRangesGroup_' + graphDataItem.htmlId;	
	};
	
	// returns stroke-dasharray css property based on graphItem lineType
	var getStrokeDashArrayFromLineType = function(lineType) {
		if (lineType == 'NONE') return '';
		
		lineType = parseInt(lineType);
		switch (lineType) {
			case 1:
				return '4, 2';
			case 2:
				return '1, 3';
			case 3:
				return '1.6, 1.8, 3.8, 1.8';
			case 4:
				return '2, 1, 2, 1, 4, 1';
			default:
				return '';
		}
	};
	
	// defines graph-specific scope functions
	this.loadServiceFunctions = function($scope) {
		// get valueLine definition
		$scope.getValueLine = function(dataTimes) {
			return $scope.viewModel.valueLine(dataTimes);
		};
		$scope.getValueLineStepped = function(dataTimes) {
			return $scope.viewModel.valueLineStepped(dataTimes);
		};
	
		// get nonLinearRefRange line definition
		$scope.getNonLinearRefRangeLine = function(data) {
			if ((angular.isArray(data)) && (data[1])) {
				var timeInterval = (data[1].timeOffset - data[0].timeOffset);
				// filter coordinates to be only those within visible range, or less than 1 interval outside visible range
				var visibleCoordinates = data.filter(function(d) {
					var coordinateAbsoluteTime = $scope.viewModel.nonLinearRefRangeBaseTime + d.timeOffset;
					return ((coordinateAbsoluteTime + timeInterval >= $scope.tcTimeFrom)
						&& (coordinateAbsoluteTime - timeInterval <= $scope.tcTimeTo));
				}).sort(function(a, b) { // sort coordinates by time so path displays correctly
					return a.timeOffset - b.timeOffset;
				});
				return $scope.viewModel.nonLinearRefRangeLine(visibleCoordinates);
			}
		};
		
		// returns a function that creates the svg marker for a given graph item
		// returns a function (rather than just the svg marker itself) for use with
		// svg selection.data/enter/exit syntax
		$scope.createMarker = function(item) {
			return function() {
				var size = $scope.viewModel.markerBaseSize;
				var element = d3.select($window.document.createElementNS(svgNS, 'g'));
				var points = '';
				if (item.marker == 1) { // square
					element.append('rect')
						.attr('width', size * 2)
						.attr('height', size * 2)
						.attr('transform', 'translate(' + -size + ',' + -size + ')');
				} else if (item.marker == 3) { // triangle
					points = '0,' + size * 2 + ' ' + size * 2 + ',' + size * 2 + ' ' + size + ',0';
					element.append('polygon')
						.attr('points', points) // '0,8 8,8 4,0'
						.attr('transform', 'translate(' + -size + ',' + -size + ')');
				} else if (item.marker == 4) { // diamond
					points = size + ',0 0,' + size + ' ' + size + ',' + size * 2 + ' ' + size * 2 + ',' + size;
					element.append('polygon')
						.attr('points', points) // '4,0 0,4 4,8 8,4'
						.attr('transform', 'translate(' + -size + ',' + -size + ')');
				} else if (item.marker == 6) { // horisontal bar
					element.append('rect')
						.attr('width', size * 2)
						.attr('height', size)
						.attr('transform', 'translate(' + -size + ',' + -size / 2 + ')');
				} else if (item.marker == 7) { // vertical bar
					element.append('rect')
						.attr('width', size)
						.attr('height', size * 2)
						.attr('transform', 'translate(' + -size / 2 + ',' + -size + ')');
				} else if (item.marker == 8) { // cross
					points = size + ',0 ' + size + ',' + size + ' 0,' + size + ' 0,' + size * 2
						+ ' ' + size + ',' + size * 2 + ' ' + size + ',' + size * 3
						+ ' ' + size * 2 + ',' + size * 3 + ' ' + size * 2 + ',' + size * 2
						+ ' ' + size * 3 + ',' + size * 2 + ' ' + size * 3 + ',' + size
						+ ' ' + size * 2 + ',' + size + ' ' + size * 2 + ',0';
					element.append('polygon')
						.attr('points', points) // '4,0 4,4 0,4 0,8 4,8 4,12 8,12 8,8 12,8 12,4 8,4 8,0'
						.attr('transform', 'translate(' + -size * 1.5 + ',' + -size * 1.5 + ')');
				} else if (item.marker == 9) { // inverted triangle
					points = '0,0 ' + size * 2 + ',0 ' + size + ',' + size * 2;
					element.append('polygon')
						.attr('points', points) // '0,0 8,0 4,8'
						.attr('transform', 'translate(' + -size + ',' + -size + ')');
				} else if (item.marker == 10) { // horisontal bar with round edges
					element.append('rect')
						.attr('width', size * 2)
						.attr('height', size)
						.attr('rx', size / 2)
						.attr('ry', size / 2)
						.attr('transform', 'translate(' + -size + ',' + -size / 2 + ')');
				} else {
					if (item.itemType !== itemTypeFluidBalance) { // circle, also marker==2
						element.append('circle')
							.attr('r', size);
					} else { // fluidBalance
						element.append('line')
							.classed('line', true)
							.attr('stroke', item.colour ? item.colour : 'black')
							.attr('stroke-width', 20);
						// just return the line element for fluid Balance, not parent group
						element = element.select('line');
					}
				}
				if (item.itemType !== itemTypeFluidBalance) {
					// Common attributes
					element.attr('stroke', item.colour)
						.classed('marker', true);
				}
				return element.node();
			};
		};
		
		// Show/hide item ews ranges
		$scope.toggleItemEWSRanges = function(graphItem, show, axisGroup) {
			axisGroup.toggleSvgGroupById(getGraphItemEWSRangesGroupId(axisGroup.htmlIdPrefix, graphItem), show, true);
		};
		
		// Show/hide Item reference range lines
		$scope.toggleItemReferenceLines = function(graphItem, show, axisGroup) {
			axisGroup.toggleSvgGroupById(getGraphItemRefRangeGroupId(axisGroup.htmlIdPrefix, graphItem), show, true);
			axisGroup.toggleSvgGroupById(getGraphItemNonLinearRefRangeGroupId(axisGroup.htmlIdPrefix, graphItem), show, true);
		};
	};
	
	// defines d3 line functions for line-type items and non-linear reference ranges
	this.serviceOnDisplay = function($scope, ctrl, axisGroup) {
		$scope.viewModel.valueLine = d3.line()
			.x(function(d) { return ctrl.getXCoordinateFromTime(d.time); })
			.y(function(d) { return ctrl.getYCoordinateFromValue(d.value, axisGroup.index, d.axesIndex); });
		
		$scope.viewModel.valueLineStepped = d3.line()
			.x(function(d) { return ctrl.getXCoordinateFromTime(d.time); })
			.y(function(d) { return ctrl.getYCoordinateFromValue(d.value, axisGroup.index, d.axesIndex); })
			.curve(d3.curveStepAfter);
		
		$scope.viewModel.nonLinearRefRangeLine = d3.line()
			.x(function(d) { return ctrl.getXCoordinateFromTime(d.timeOffset + $scope.viewModel.nonLinearRefRangeBaseTime); })
			.y(function(d) { return ctrl.getYCoordinateFromValue(d.value, axisGroup.index, d.axesIndex); });
		
		var scrollableContainer = axisGroup.getDataSvgContainer();
		scrollableContainer.append('rect')
			.classed('popoverSelection', true)
			.attr('id', axisGroup.htmlIdPrefix + '-popoverSelection')
			.attr('stroke-width', dimensions.selectionBorderThickness + 'px');

		// returns all the graph markers' data inside the touch target area of the finger tap on the screen.
		// but returns an empty array if the tap position is exactly inside a marker 
		// (in this case, we use popoverMarkerHandler instead of popoverTouchHandler)
		var getAllMarkersDataInTouchTarget = function(mouseX, mouseY, size, markerSize) {

			// returns the graph markers'data inside the touch target area for a given list of graph item markers
			// This helper function can be used for medication orders (RX) and/or Observations/Lab Results
			var getMarkersDataInTouchTargetFromMarkerList = function(dataTimes, isOutOfRangeData) {
				for (var dataIndex = 0; dataIndex < dataTimes.length; dataIndex++) {
					var data = dataTimes[dataIndex];
					var dx = Math.abs(ctrl.getXCoordinateFromTime(data.time) - mouseX);					// x-pixel distance of the marker to the mouse position
					var y = '';
					if (!isOutOfRangeData) {
						y = ctrl.getYCoordinateFromValue(data.value, 0, axisIndex);
					} else {
						y = getOutOfRangeDataYCoordinate($scope, axisGroup, data.value, data.axesIndex);
					}
					var dy = Math.abs(y - mouseY);	// y-pixel distance of the marker to the mouse position
					if ((dx <= size / 2) && (dy <= size / 2)) {
						// The marker is close to the finger tap position
						if ((dx * dx + dy * dy)  <= (markerSize * markerSize)) {
							// The finger tap position is inside the marker area. 
							// Break: do not show the popover with the neighboring items. 
							MarkersData = [];
							isInMarker = 1;
							break;
						}
						MarkersData.push(getMarkerData(item, data));
					}

				}
				var result = {
					MarkersData: MarkersData,
					isInMarker: isInMarker
				};
				return result;
			};

			var MarkersData = []; // List of markers inside the touch target area (but returns an empty list if tap is exactly on the marker)
			var isInMarker = 0;
			for (var axisIndex = 0; axisIndex < axisGroup.yAxes.length; axisIndex++) {
				var axis = axisGroup.yAxes[axisIndex];
				if (isInMarker) {break;}

				for (var itemIndex = 0; itemIndex < axis.items.length; itemIndex++) {
					if (isInMarker) {break;}	
					var item = axis.items[itemIndex];

					// Check for in-range neighboring markers
					var result = getMarkersDataInTouchTargetFromMarkerList(item.dataTimes, 0);
					MarkersData = result.MarkersData;
					isInMarker = result.isInMarker;
					if (isInMarker) {break;}

					// Check for out-of-range neighboring markers
					result = getMarkersDataInTouchTargetFromMarkerList(item.outOfRangeData, 1);
					MarkersData = result.MarkersData;
					isInMarker = result.isInMarker;
					if (isInMarker) {break;}

					// Check for neighboring order markers
					var orders = item.orders;
					if (angular.isDefined(orders)) {
						for (var orderIndex = 0; orderIndex < orders.length; orderIndex++) {
							var order = orders[orderIndex];
							result = getMarkersDataInTouchTargetFromMarkerList(order.markers, 0);
							MarkersData = result.MarkersData;
							isInMarker = result.isInMarker;
							if (isInMarker) {break;}

						}
					}
					
				}

			}
			if (isInMarker) {
				MarkersData = [];
			}
			return MarkersData;

		};

		// Add popover when tapping around the marker (but not tapping the marker itself)
		var popoverTouchHandler = function() {
			var size = dimensions.size; // Touch target size
			var markerSize = $scope.viewModel.markerBaseSize; // Graph Marker Base Size

			var mouseTime = $scope.tcXScale.invert(d3.mouse(scrollableContainer.node())[0]);
			var mouseX = ctrl.getXCoordinateFromTime(mouseTime);	// x-pixel coordinate
			var mouseY = d3.mouse(scrollableContainer.node())[1];	// y-piexl coordinate

			// Find all the markers inside the touch target area
			var MarkersData = getAllMarkersDataInTouchTarget(mouseX, mouseY, size, markerSize);
			if (MarkersData.length === 0) return;

			// Transparent square popover selection, which represents the finger tap touch target area
			var popoverSelection = scrollableContainer.select('rect.popoverSelection')
				.attr('x', mouseX - size / 2)
				.attr('y', mouseY - size / 2)
				.attr('height', size)
				.attr('width', size)
				.style('opacity', 0); 
			scrollableContainer.node().appendChild(popoverSelection.node()); // brings popoverSelection to front

			var MarkersDataJSON = encodeURIComponent(angular.toJson(MarkersData)); // Encode URI before passing it to popoverParams
			var popoverParams = axisGroup.popoverParams + '&MarkersData=' + MarkersDataJSON;

			$scope.$emit('Timeline:pauseAutoRefresh', {reason: 'Popover'});

			var overlayOptions = {
				event: d3.event,
				componentName: 'system.Timeline.Graph.Popover', 
				params: popoverParams,
				popoverFor: popoverSelection.attr('id'),
				onRemovingHandler: function() {
					popoverSelection.style('opacity', 0);
					$scope.$emit('Timeline:playAutoRefresh', {reason: 'Popover'});
				}
			};
			OverlayService.open(overlayOptions);
		};
		axisGroup.getMainGraphSvg().on('touchstart', popoverTouchHandler);		
	};
	
	// adds additional watches for the graph items
	this.addServiceWatches = function($scope, ctrl, axisGroup) {
		angular.forEach(axisGroup.yAxes, function(axis, axisIndex) {
			angular.forEach(axis.items, function(item, itemIndex) {
				// watch item.showEWSRanges to determine whether EWS ranges should be shown/hidden
				var ewsRangeWatchExpr = 'data.axisGroups[' + axisGroup.index + '].yAxes[' + axisIndex
										+ '].items[' + itemIndex + '].showEWSRanges';
				$scope.$watch(ewsRangeWatchExpr, function(newValue) {
					// reset item in case new data has been bound in from a parent scope
					item = axisGroup.yAxes[axisIndex].items[itemIndex];
					
					$scope.toggleItemEWSRanges(item, newValue, axisGroup);
				});
				
				// watch item.showReferenceLines to determine whether reference ranges should be shown/hidden
				var refRangeWatchExpr = 'data.axisGroups[' + axisGroup.index + '].yAxes[' + axisIndex
										+ '].items[' + itemIndex + '].showReferenceLines';
				$scope.$watch(refRangeWatchExpr, function(newValue) {
					// reset item in case new data has been bound in from a parent scope
					item = axisGroup.yAxes[axisIndex].items[itemIndex];
					
					$scope.toggleItemReferenceLines(item, newValue, axisGroup);
					
					axisGroup.drawAxisItems(axis, true); // TODO: remove once we have a draw trigger
				});
			});
		});
	};
	
	// Adds item markers and units to the appropriate axis
	this.getDecorateAxis = function($scope, ctrl, axisGroup) {
		var drawItemUnits = function(container) {
			var axisGroupModel = $scope.viewModel.axisGroupModel[axisGroup.index];
			var height = axisGroupModel.dimensions.height;
			angular.forEach(axisGroup.yAxes, function(axis, axisIndex) {
				if (angular.isDefined(axis)) {
					var longestRowWidth = 0;
					var rowWidth = 0;
					var rowHeightOffset  = 0;
					var isLeftAxis = ctrl.isLeftAxis(axisIndex);
					var axisUnitsGroup = TimelineService.getOrCreateSvgElementById(
						getAxisUnitsGroupId(axisGroup.htmlIdPrefix, axisIndex),
						'g',
						container
					);
				
					var itemUnitGroups = axisUnitsGroup
						.selectAll('g.itemUnitGroup_' + axisIndex)
						.data(axis.items, function(d) {return d.caption;});

					itemUnitGroups.enter()
						.append('g')
						.classed('itemUnitGroup_' + axisIndex, true)
						.attr('id', function(d) { return getItemUnitsGroupId(axisGroup.htmlIdPrefix, d);})
						.each(function(item) {
							// Add marker and text element for each graph item
							var elementSelection = d3.select(this);
							elementSelection.append(function(item) {
								return $scope.createMarker(item)();
							})
							.attr('fill', $scope.viewModel.markerDefaultFillColor)
							.attr('transform', 'translate('
								+ (-$scope.viewModel.markerBaseSize * 2) + ','
								+ (-$scope.viewModel.markerBaseSize) + ')');
							if (item.itemType === itemTypeFluidBalance) {
								elementSelection.selectAll('line').attr('x1', 0)
									.attr('stroke-width', 10)
									.attr('transform', 'translate(-12, -3)')
									.attr('x2', 10)
									.attr('y2', 0)
									.attr('y1', 0);
							}
							
							// if units has sub/superscript, need to add separate text spans to support
							if ((item.units.indexOf('<sup>') !== -1) || (item.units.indexOf('<sub>') !== -1)) {
								var tag = ((item.units.indexOf('<sup>') !== -1) ? 'sup' : 'sub');
								var text = elementSelection.append('text');
								text.append('tspan')
									.classed('pre' + tag, true);
								text.append('tspan')
									.classed(tag, true)
									.attr('y', (tag === 'sup' ? -5 : 5));
								text.append('tspan')
									.classed('post' + tag, true)
									.attr('y', 0);
							} else {
								elementSelection.append('text');	
							}
						})
						.merge(itemUnitGroups)
						.each(function(item) {
							// set unit text based on showLegend value
							var elementSelection = d3.select(this);
							var legendItemUnitsText = ($scope.tcShowLegend ? item.units : $scope.getLegendItemCaption(item));
							var textSelection = elementSelection.select('text')
								.classed('itemUnits', true)
								.classed('graphLabelText', $scope.tcShowLegend);
							if ((legendItemUnitsText.indexOf('<sup>') !== -1) || (legendItemUnitsText.indexOf('<sub>') !== -1)) {
								var tag = ((legendItemUnitsText.indexOf('<sup>') !== -1) ? 'sup' : 'sub');
								var openingTagSplit = legendItemUnitsText.split('<' + tag + '>');
								var pre = openingTagSplit[0];
								var closingTagSplit = openingTagSplit[1].split('</' + tag + '>');
								var tagValue = closingTagSplit[0];
								var post = closingTagSplit[1];
								textSelection.select('tspan.pre' + tag).text(pre);
								textSelection.select('tspan.' + tag).text(tagValue);
								textSelection.select('tspan.post' + tag).text(post);
							} else {
								textSelection.text(legendItemUnitsText);
							}
							// add width of item marker/caption to total width 
							var bbox = elementSelection.node().getBBox();
							var itemWidth = bbox.width + 5;
							if (rowWidth + itemWidth > height) {
								// need to wrap to next row
								rowHeightOffset += 15;
								rowWidth = 0;
							}
							// shift this item marker/caption by rowwidth so multiple items don't overlap
							elementSelection.attr('transform', 'translate(' +  rowWidth + ',' + rowHeightOffset + ')');
							rowWidth += itemWidth;
							longestRowWidth = Math.max(longestRowWidth, rowWidth);
						});

					itemUnitGroups.exit().remove();

					var translateHeight = 0;
					if (isLeftAxis) {
						// Account for the first marker's size and shift/centering to prevent it from getting cropped
						translateHeight = (-longestRowWidth / 2) - (height / 2) + ($scope.viewModel.markerBaseSize * 1.5);
					} else {
						translateHeight = (height / 2) - (longestRowWidth / 2);
					}
					var unitsMargin = axisGroupModel.dimensions.margin.left - 25;
					var translateWidth = (isLeftAxis ? -unitsMargin : -axisGroupModel.dimensions.width - unitsMargin);
					var rotation = (isLeftAxis ? 270 : 90);
					// shift parent Group element such that item unit captions are centered around middle of graph
					axisUnitsGroup.attr('transform', 
						'rotate(' + rotation + ') translate(' + translateHeight + ',' + translateWidth + ')');
				}
			});
		};
		
		return drawItemUnits;
	};
	
	// Adds additional axis tick styling (mostly for fluid balance graphs)
	this.getStyleAxisTicks = function($scope) {
		var styleAxisTicks = function(g) {
			g.attr('font-size', '');
			if ($scope.data.isFluidBalanceGraph) {
				g.selectAll('.tick line')
		.style('opacity', function(d) {
					if (d === 0) {
						return 1;
					} else {
						return 0.25;	
					}
				}); 
			}
		};
		
		return styleAxisTicks;
	};
	
	// graph item drawing logic
	this.getDrawAxisItemData = function($scope, ctrl, axisGroup) {
		// draws various graph elements based on the graphItem settings
		var drawAxisItemData = function(axis, axisSVGGroup, item, itemGroup, transition) {
			if (item.itemType === itemTypeLine) {
				drawGroupLine(item, itemGroup, item, transition);
			} else if (item.itemType === itemTypeRX) {
				drawItemOrderGroups(itemGroup, item, transition);
			} else if (item.itemType === itemTypeFluidBalance) {
				drawItemFluidBalance(itemGroup, item, transition);
			}
			
			if (item.linkedItem) {
				if (angular.isUndefined(item.linkedItemObj)) {
					var linkedItemObj = axis.items.filter(function(d) { return d.caption === item.linkedItem; })[0];
					item.linkedItemObj = linkedItemObj;
					linkedItemObj.linkedItemObj = item;
				}
				drawItemLink(itemGroup, item, transition);
			}
			
			if ((item.itemType !== itemTypeFluidBalance) && (item.itemType !== itemTypeRX)) {
				drawGroupMarkers(item, itemGroup, item, transition);
			}
		
			// Out of range data
			var itemOutOfRangeGroup = TimelineService.getOrCreateSvgElementById(
				getGraphItemOutOfRangeGroupId(axisGroup.htmlIdPrefix, item),
				'g',
				axisGroup.getAxisSvgContainer()
			); 
			drawItemOutOfRangeMarkers(itemOutOfRangeGroup, item, transition);
		
			// Draw reference ranges for this item  
			if ((angular.isArray(item.refRanges)) && (item.refRanges.length > 0)) drawItemReferenceLines(item, axis);
			if (angular.isArray(item.nonLinearReferenceRanges)) drawItemNonLinearReferenceRanges(item);
		
			if (item.showEWSRanges) drawItemEWSRanges(item, axis);
		};
		
		// Creates new groups based on data from the orders layer
		// Calls helper methods to draw lines and markers for each order group
		var drawItemOrderGroups = function(itemGroup, item, transition) {
			var orderGroups = itemGroup.selectAll('g.orderGroup')
				.data(item.orders, function(order) {return order.htmlId;});
			
			var prefix = axisGroup.getAxisItemGroupId(item);
			
			orderGroups.enter()
				.append('g')
				.classed('orderGroup', true)
				.attr('id', function(order) { return getItemOrderGroupId(prefix, order); })
			.merge(orderGroups)
				.each(function(order) {
					var orderGroup = d3.select(this);
					
					drawGroupLine(item, orderGroup, order, transition);
					drawGroupMarkers(item, orderGroup, order, transition);
				});
				
			orderGroups.exit().remove();
		};
		
		// Draws line connecting all markers within a group
		var drawGroupLine = function(graphItem, group, groupItem, transition) {
			if (graphItem.lineType == 'NONE') return;
			
			var arrMarkers;
			var lineClass = 'line';
			var prefix = axisGroup.getAxisItemGroupId(graphItem);
			if (graphItem.itemType == itemTypeRX) {
				arrMarkers = groupItem.markers;
				lineClass = itemTypeRX + lineClass;
				prefix = getItemOrderGroupId(prefix, groupItem);
			} else {
				arrMarkers = groupItem.dataTimes;
			}
			
			// Get marker data from the group, keying on time
			var line = group
				.selectAll('path')
				.data([arrMarkers]); // markers within a group will be connected by a single path
			
			line.enter()
				.append('path')
				.classed(lineClass, true)
				.attr('id', prefix + '-line')
				.attr('fill', 'none')
				.attr('stroke', graphItem.colour)
				.attr('stroke-width', 1.5)
				.attr('stroke-dasharray', getStrokeDashArrayFromLineType(graphItem.lineType))
			.merge(line)
				.transition(transition)
				.attr('d', ((graphItem.GenericType == 'DDR') ? $scope.getValueLineStepped : $scope.getValueLine));
		
			line.exit().remove();
		};
		
		// draws markers for fluid balance items
		var drawItemFluidBalance = function(itemGroup, item, transition) {
			// get line selection, keying the data on time
			var bar = itemGroup
				.selectAll('line')
				.data(item.dataTimes, function(d) { return d.time; });
			
			bar.enter()
				.append($scope.createMarker(item))
				.on('mouseover', function(d) { markerMouseoverFunction(item, d, axisGroup); })
				.on('mouseout', function() { markerMouseoutFunction(axisGroup); })
			.merge(bar)
				.transition(transition)
				.attr('x1', function(d) {return ctrl.getXCoordinateFromTime(d.time);})
				.attr('y1', function(d) {return ctrl.getYCoordinateFromValue(d.totalValue, axisGroup.index, d.axesIndex);})
				.attr('x2', function(d) {return ctrl.getXCoordinateFromTime(d.time);})
				.attr('y2', function(d) {
					return ctrl.getYCoordinateFromValue(d.totalValue - d.value, axisGroup.index, d.axesIndex);
				});
			bar.exit().remove();
		};
		
		// draws the line linking linked items
		var drawItemLink = function(itemGroup, item, transition) {
			// get line selection, keying the data on time
			var itemLinkData = [];
			var linkedItem = item.linkedItemObj;
			if (!linkedItem) return;
		
			angular.forEach(item.dataTimes, function(dataTime) {
				var linkedDataTime = linkedItem.dataTimes.filter(function(d) {return d.time == dataTime.time;})[0];
				itemLinkData.push({
					time: dataTime.time,
					value: dataTime.value,
					axesIndex: dataTime.axesIndex,
					linkedValue: linkedDataTime ? linkedDataTime.value : dataTime.value,
				});
			});
		
			var line = itemGroup
				.selectAll('line')
				.data(itemLinkData, function(d) {return d.time;});
			
			line.enter()
				.append('line')
				.classed('line', true)
				.attr('fill', 'none')
				.attr('stroke', item.colour)
				.attr('stroke-width', 1.5)
				.attr('stroke-dasharray', getStrokeDashArrayFromLineType(linkedItem.lineType))
			.merge(line)
				.transition(transition)
				.attr('x1', function(d) {return ctrl.getXCoordinateFromTime(d.time);})
				.attr('y1', function(d) {
					var markerOffset = (d.value > d.linkedValue ?
										$scope.viewModel.markerBaseSize : -$scope.viewModel.markerBaseSize);
					return ctrl.getYCoordinateFromValue(d.value, axisGroup.index, d.axesIndex) + markerOffset;
				})
				.attr('x2', function(d) {return ctrl.getXCoordinateFromTime(d.time);})
				.attr('y2', function(d) {
					var markerOffset = (d.linkedValue > d.value ?
										$scope.viewModel.markerBaseSize : -$scope.viewModel.markerBaseSize);
					return ctrl.getYCoordinateFromValue(d.linkedValue, axisGroup.index, d.axesIndex) + markerOffset;
				});
		
			line.exit().remove();
		};
		
		// Draws in-range markers for given group
		var drawGroupMarkers = function(graphItem, group, groupItem, transition) {
			var arrMarkers;
			var prefix = axisGroup.getAxisItemGroupId(graphItem);
			if (graphItem.itemType == itemTypeRX) {
				prefix = getItemOrderGroupId(prefix, groupItem);
				
				// Filter out markers with displayOFF (those are used to plot the line ONLY)
				arrMarkers = groupItem.markers;
				arrMarkers = arrMarkers.filter(function(d) {return !d.displayOFF;});
			} else {
				arrMarkers = groupItem.dataTimes;
			}
			
			// Add markers, keying data on time
			var markers = group
				.selectAll('.marker')
				.data(arrMarkers, function(d) { return d.time; });
			
			markers.enter()
				.append($scope.createMarker(graphItem))
				.on('mouseover', function(d) { markerMouseoverFunction(graphItem, d);})
				.on('mouseout', function() { markerMouseoutFunction(); })
				.on('click', function(d) { 
					markerMouseoutFunction();
					popoverMarkerHandler(graphItem, d, prefix); 
				})
			.merge(markers)
				.transition(transition)
				.attr('fill', function(d) { 
					if ((!d.inRefRange) && (graphItem.showReferenceLines)) {
						return graphItem.colour;
					}
					return $scope.viewModel.markerDefaultFillColor;
				})
				.attr('id', function(d) { return getMarkerId(prefix, d); }) // id, time and value are used for scripting
				.attr('time', function(d) { return d.time; })
				.attr('value', function(d) { return d.value; })
				.attr('transform', function(d) {
					return 'translate(' + ctrl.getXCoordinateFromTime(d.time) + ',' 
						+ ctrl.getYCoordinateFromValue(d.value, axisGroup.index, d.axesIndex) + ')';
				});
			
			markers.exit().remove();
		};
		
		// Draws markers for data items that are outside the configured axis range
		// Note: no special case for orders as out-of-range markers are all stored together
		//       (though such markers' htmlIds will start with order htmlID for uniqueness)
		var drawItemOutOfRangeMarkers = function(itemGroup, item, transition) {
			var visibleData = item.outOfRangeData.filter(function(d) {
					return (!((d.time > $scope.tcTimeTo) || (d.time < $scope.tcTimeFrom)));
				});
			
			var prefix = getGraphItemOutOfRangeGroupId(axisGroup.htmlIdPrefix, item);
			
			var outOfRangeMarkers = itemGroup
				.selectAll('.outOfRangeMarker')
				.data(visibleData, function(d) { return d.time; });
			
			outOfRangeMarkers.enter()
				.append($scope.createMarker(item))
				.classed('outOfRangeMarker', true)
				.attr('fill', item.colour) 
				.on('mouseover', function(d) { markerMouseoverFunction(item, d); })
				.on('mouseout', function() { markerMouseoutFunction(); })
				.on('click', function(d) { 
					markerMouseoutFunction();
					popoverMarkerHandler(item, d, prefix);
				})
			.merge(outOfRangeMarkers)
				.transition(transition)
				.attr('id', function(d) { return getMarkerId(prefix, d); }) // id, time and value are used for scripting
				.attr('time', function(d) { return d.time; })
				.attr('value', function(d) { return d.value; })
				.attr('transform', function(d) {
					return 'translate(' + ctrl.getXCoordinateFromTime(d.time) + ',' 
						+ getOutOfRangeDataYCoordinate($scope, axisGroup, d.value, d.axesIndex) + ')';
				});
			
			outOfRangeMarkers.exit().remove();
		};
		
		// Draws reference lines/markers for an item
		var drawItemReferenceLines = function(item, axis) {
			var axisGroupModel = $scope.viewModel.axisGroupModel[axisGroup.index];
			var container = axisGroup.getAxisSvgContainer();
			var lineOutsetMargin = $scope.viewModel.markerBaseSize;
		
			var refRangeGroupId = getGraphItemRefRangeGroupId(axisGroup.htmlIdPrefix, item);
			var refRangeGroup = TimelineService.getOrCreateSvgElementById(refRangeGroupId, 'g', container);
			// show/Hide Ref ranges based on item.showReferenceLines property
			refRangeGroup.style('opacity', (item.showReferenceLines ? 1 : 0));
		
			var visibleRefRanges = item.refRanges.filter(function(d) {
				return ((d.value >= axis.axisMin) && (d.value <= axis.axisMax));
			});
		
			var lines = refRangeGroup
				.selectAll('line')
				.data(visibleRefRanges, function(d) { return d.label; });
		
			lines.enter()
				.append('line')
				.attr('stroke', item.refRangeColour)
				.attr('stroke-dasharray', getStrokeDashArrayFromLineType(item.refRangeLineType))
			.merge(lines)
				.attr('x1', function(d) { 
						return ((ctrl.isRightAxis(d.axesIndex))
							? axisGroupModel.dimensions.width + lineOutsetMargin
							: -lineOutsetMargin);
					})
				.attr('x2', function(d) { 
					return ((ctrl.isRightAxis(d.axesIndex)) ? 0 : axisGroupModel.dimensions.width);
				})
				.attr('y1', function(d) { return ctrl.getYCoordinateFromValue(d.value, axisGroup.index, d.axesIndex);})
				.attr('y2', function(d) { return ctrl.getYCoordinateFromValue(d.value, axisGroup.index, d.axesIndex);});
			
			lines.exit().remove();
		
			var markers = refRangeGroup
				.selectAll('g.marker')
				.data(visibleRefRanges, function(d) {return d.label;});
		
			markers.enter()
				.append($scope.createMarker(item))
				.attr('stroke', item.refRangeColour)
				.attr('fill', $scope.viewModel.markerDefaultFillColor)
				.on('mouseover', function(d) { markerMouseoverFunction(item, d);})
				.on('mouseout', function() { markerMouseoutFunction(); })
			.merge(markers)
				.attr('transform', function(d) {
					var xOffset = ((ctrl.isRightAxis(d.axesIndex))
									? axisGroupModel.dimensions.width + $scope.viewModel.markerBaseSize + 3
									: -$scope.viewModel.markerBaseSize - 2);
					return 'translate(' + xOffset + ',' + ctrl.getYCoordinateFromValue(d.value, axisGroup.index, d.axesIndex) + ')';
				});
	
			markers.exit().remove();
		};
		
		// draw lines and captions for non linear reference ranges
		var drawItemNonLinearReferenceRanges = function(item) {
			var axisGroupModel = $scope.viewModel.axisGroupModel[axisGroup.index];
			var groupId = getGraphItemNonLinearRefRangeGroupId(axisGroup.htmlIdPrefix, item);
			var refRangeGroup = TimelineService.getOrCreateSvgElementById(groupId, 'g', axisGroup.getDataSvgContainer());
			// show/Hide Ref ranges based on item.showReferenceLines property
			refRangeGroup.style('opacity', (item.showReferenceLines ? 1 : 0));
		
			var lineGroups = refRangeGroup
				.selectAll('g.nonLinearRefRangeGroup')
				.data(item.nonLinearReferenceRanges, function(d) { return d.id; });
		
			var groupIdPrefix = groupId + '_';
			var pathIdPrefix = groupId + '_path_';
			var textIdPrefix = groupId + '_text_';
			lineGroups.enter()
				.each(function(d, index) {
					var elementSelection = d3.select(this);
					var group = elementSelection.append('g')
						.classed('nonLinearRefRangeGroup', true)
						.attr('id', groupIdPrefix + index);
						
					var pathId = pathIdPrefix + index;
					// Add line path element
					group.append('path')
						.attr('id', pathId)
						.attr('fill', 'none')
						.attr('stroke', d.colour)
						.attr('stroke-dasharray', getStrokeDashArrayFromLineType(d.lineType));
					
					// Add text element for caption and append textPath based on path
					group.append('text')
						.classed('graphLabelText', true)
						.style('fill', d.colour)
						.attr('dy', 3)
						.attr('text-anchor', 'end')
						.attr('id', textIdPrefix + index)
						.append('textPath')
						.attr('xlink:href', '#' + pathId)
						.text(d.caption);
				})
			.merge(lineGroups)
				.each(function(d, index) {
					var groupSelection = d3.select(this);
					// update path d attribute 
					var pathId = pathIdPrefix + index;
					var pathSelection = groupSelection.select('#' + pathId);
					pathSelection.attr('d', $scope.getNonLinearRefRangeLine(d.coordinates));
		
					// update position of caption
					var captionRightMargin = 10;
					var pathStartOffset = ctrl.getXCoordinateFromTime($scope.viewModel.nonLinearRefRangeBaseTime);
					// position caption 10px from right end of visible window 
					var newCaptionPosition = (-1 * pathStartOffset) + axisGroupModel.dimensions.width - captionRightMargin;
					var pathEnd = pathSelection.node().getBBox().width;
					if (newCaptionPosition > pathEnd) {
						// if ref range line ends before the right end of visible window,
						//anchor caption 10px from end of line
						newCaptionPosition = pathEnd - captionRightMargin;  
					}
					groupSelection.select('#' + textIdPrefix + index)
						.attr('x', newCaptionPosition);
				});
			
			lineGroups.exit().remove();
		};
		
		// Draw/update ews Ranges relevant for the displayed time window
		var drawItemEWSRanges = function(item, axis) {
			var axisGroupModel = $scope.viewModel.axisGroupModel[axisGroup.index];
			var getXValue = function(d) {
				return (d.JSTimeFrom > $scope.tcTimeFrom ? ctrl.getXCoordinateFromTime(d.JSTimeFrom) : 0);
			};
		
			var getYValue = function(d) {
				return (d.roundedUpperValue < axis.axisMax ?
						ctrl.getYCoordinateFromValue(d.roundedUpperValue, axisGroup.index, axis.axesIndex) : 0);
			};
		
			var getWidth = function(d) {
				var rectEnd = (d.JSTimeTo <  $scope.tcTimeTo
					? ctrl.getXCoordinateFromTime(d.JSTimeTo)
					: axisGroupModel.dimensions.width);
				var rectStart = getXValue(d);
				var width = rectEnd - rectStart;
				
				return (width > 0 ? width : 0);
			};
		
			var getHeight = function(graphItem, d) {
				var rectBottom = (d.lowerValue > axis.axisMin
					? ctrl.getYCoordinateFromValue(d.lowerValue, axisGroup.index, axis.axesIndex)
					: axisGroupModel.dimensions.height);
				var rectTop = getYValue(d);
				var height = rectBottom - rectTop;
				
				return (height > 0 ? height : 0);
			};
		
			var visibleRanges = item.ewsRanges.filter(function(d) {
					return (!((d.JSTimeFrom > $scope.tcTimeTo) || (d.JSTimeTo < $scope.tcTimeFrom)));
				});
		
			var ewsRangesGroupId = getGraphItemEWSRangesGroupId(axisGroup.htmlIdPrefix, item);
			var ewsRangesGroup = TimelineService.getOrCreateSvgElementById(ewsRangesGroupId, 'g', axisGroup.getDataSvgContainer());
		
			var rects = ewsRangesGroup
				.selectAll('rect')
				.data(visibleRanges, function(d) {return (d.lowerValue + '^' + d.roundedUpperValue + '^' + d.JSTimeFrom);});
		
			rects.enter()
				.append('rect')
				.classed('EWSRange', true)
				.attr('fill', function(d) { return d.colour;})
				.attr('opacity', 0.5)
			.merge(rects)
				.attr('x', function(d) { return getXValue(d);})
				.attr('y', function(d) { return getYValue(d);})
				.attr('width', function(d) { return getWidth(d);})
				.attr('height', function(d) { return getHeight(item, d);});
			
			rects.exit().remove();
		};
		
		// mouseover listener to render tooltip for markers
		var markerMouseoverFunction = function(graphItem, marker) {
			var tooltip = axisGroup.getTooltip();
			tooltip.transition()		
				.duration(200)
				.style('opacity', .9);
							
			tooltip.html(getMarkerTooltip(graphItem, marker));
			
			tooltip.style('left', (d3.event.pageX) + 'px')
				.style('top', (d3.event.pageY - 70) + 'px');
		};
	
		// mouseout listener for markers to hide tooltip
		var markerMouseoutFunction = function() {
			var tooltip = axisGroup.getTooltip();
			tooltip.transition()		
				.duration($scope.viewModel.transitionDuration)
				.style('opacity', 0);
		};
		
		// Add popover when clicking on the marker
		var popoverMarkerHandler = function(graphItem, marker, prefix) {
			var MarkersData = []; 
			MarkersData.push(getMarkerData(graphItem, marker));
			var MarkersDataJSON = encodeURIComponent(angular.toJson(MarkersData)); // Encode URI before passing it to popoverParams
			var popoverFor = getMarkerId(prefix, marker);
			var popoverParams = axisGroup.popoverParams + '&MarkersData=' + MarkersDataJSON;
			$scope.$emit('Timeline:pauseAutoRefresh', {reason: 'Popover'});
			var overlayOptions = {
				event: d3.event,
				componentName: 'system.Timeline.Graph.Popover', 
				params: popoverParams,
				popoverFor: popoverFor,
				onRemovingHandler: function() {
					$scope.$emit('Timeline:playAutoRefresh', {reason: 'Popover'});
				}
			};
			OverlayService.open(overlayOptions);
		};

		// Get contents of marker tooltip
		var getMarkerTooltip = function(itemData, markerData) {
			var isRX = (itemData.itemType == itemTypeRX);
			
			var tooltip = (isRX && (markerData.itemDesc !== '')) ? markerData.itemDesc : itemData.caption;	
			
			if (isRX && (markerData.route !== '')) tooltip += '<br/>' + markerData.route;
			if (angular.isNumber(markerData.time)) {
				tooltip += '<br/>';
				if (isRX && (markerData.adminStatus !== '')) tooltip += markerData.adminStatus + ' ';
				tooltip += TimelineService.getTimestamp(markerData.time);
			}
			
			var tooltipVal = markerData.dispValue;
		
			if (tooltipVal !== '') {
				tooltip += '<br/>' + '<b>' + tooltipVal + ' ' + itemData.units + '</b>';
				if (isRX && (markerData.prescribedAs !== '')) tooltip += ' ' + markerData.prescribedAs;
			}
		
			return tooltip;
		};
		
		return drawAxisItemData;
	};

	// Get contents of marker popover. (same as getMarkerTooltip but returns an object instead of a text string)
	var getMarkerData = function(itemData, markerData) {
		var isRX = (itemData.itemType == itemTypeRX);
		var MarkerData = angular.fromJson(angular.toJson(markerData)); // Deep copy: "MarkerData" is disconnected from the original "markerData"
		MarkerData.caption = (isRX) ? markerData.itemDesc : itemData.caption;
		var value = markerData.dispValue;
		if (value !== '') {
			MarkerData.value = value + ' ' + itemData.units;
		}
		return MarkerData;
	};
	
	// Return Y Coordinate for data points that are outside the configured axis range
	var getOutOfRangeDataYCoordinate = function($scope, axisGroup, value, axesIndex) {
		var axis = $scope.data.axisGroups[axisGroup.index].yAxes[axesIndex];
		var axisGroupModel = $scope.viewModel.axisGroupModel[axisGroup.index];
		if (angular.isObject(axis)) {
			if (((axis.axisMax > axis.axisMin) && (value > axis.axisMax))
				|| ((axis.axisMax < axis.axisMin) && (value < axis.axisMax))) {
				return -5;
			} else {
				return axisGroupModel.dimensions.height + 5;
			}
		}
	};
	this.getGetItemLegendMarkerHtml = function($scope) {
		// returns string of html to go in svg element for each legend item marker
		var getItemLegendMarkerHtml = function(item) {
			var markerHtmlSelection;
			if (item.itemType !== itemTypeFluidBalance) {
				var markerGroup = $scope.createMarker(item)();
				markerHtmlSelection = d3.select(markerGroup);
				markerHtmlSelection.attr('fill', $scope.viewModel.markerDefaultFillColor);

				var offsetX = $scope.viewModel.legendMarkerWidth / 2;
				var offsetY = $scope.viewModel.legendMarkerHeight / 2; 
				markerHtmlSelection.attr('transform', 'translate(' + offsetX + ',' + offsetY + ')');

				markerHtmlSelection.insert('line', ':first-child')
					.attr('x1', -offsetX)
					.attr('y1', 0)
					.attr('x2', offsetX)
					.attr('y2', 0)
					.attr('stroke-width', (item.lineType == 'NONE' ? 0 : 1.5))
					.attr('stroke-dasharray', getStrokeDashArrayFromLineType(item.lineType));
			} else {
				var lineNode = $scope.createMarker(item)();
				markerHtmlSelection = d3.select(lineNode);
				markerHtmlSelection
					.attr('x1', 10)
					.attr('y1', 0)
					.attr('x2', 10)
					.attr('y2', $scope.viewModel.legendMarkerHeight);
			}
			var svgNode = d3.select($window.document.createElementNS(svgNS, 'svg'))
				.attr('width', $scope.viewModel.legendMarkerWidth)
				.attr('height', $scope.viewModel.legendMarkerHeight)
				.node();
			svgNode.appendChild(markerHtmlSelection.node());
			// outerHTML not supported in IE11, so use XMLSerializer
			var html = svgNode.outerHTML || new XMLSerializer().serializeToString(svgNode); // eslint-disable-line
		
			return $sce.trustAsHtml(html);
		};
		
		return getItemLegendMarkerHtml;
	};
	
	this.getVisibleHandler = function() {
		// when an item's visibility is toggled, make sure linked item has same visibility
		var VisibleHandler = function(item) {
			if (item && item.linkedItemObj) item.linkedItemObj.visible = item.visible;
		};
		
		return VisibleHandler;
	};
	
	this.getOnToggleItemVisibility = function($scope, ctrl, axisGroup) {
		// also toggle out of range markers, reference ranges, EWS ranges, and item units
		var onToggleItemVisibility = function(item) {
			axisGroup.toggleSvgGroupById(getGraphItemOutOfRangeGroupId(axisGroup.htmlIdPrefix, item), item.visible, true);
			
			var showReferenceLines = (angular.isDefined(item.showReferenceLines) && item.visible
				? item.showReferenceLines
				: item.visible);
			$scope.toggleItemReferenceLines(item, showReferenceLines, axisGroup);
			
			var showEWSRanges = (angular.isDefined(item.showEWSRanges) && item.visible ? item.showEWSRanges : item.visible);
			$scope.toggleItemEWSRanges(item, showEWSRanges, axisGroup);
			
			toggleItemUnits(item, item.visible, axisGroup);
		};
		
		// toggle item units displayed along the axis
		var toggleItemUnits = function(graphItem, show) {
			axisGroup.toggleSvgGroupById(getItemUnitsGroupId(axisGroup.htmlIdPrefix, graphItem), show, true);
		};
		
		return onToggleItemVisibility;
	};
	
	this.getGetExtraActionMenuItems = function($scope) {
		// Create action Menu Items for EWS system and visible EWS ranges
		var getEWSActionMenuItems = function(graphItem) {
			var visibleEWSRanges = graphItem.ewsRanges.filter(function(d) {
					return (!((d.JSTimeFrom > $scope.tcTimeTo) || (d.JSTimeTo < $scope.tcTimeFrom)));
				}).sort(function(a, b) {
					return a.lowerValue - b.lowerValue;
				});
		
			var ewsRangeActionMenuItems = [];
			var ewsSystem = '';
			angular.forEach(visibleEWSRanges, function(rangeObj, index) {
				var rangeEWSSystem = rangeObj.system;
				if ((ewsSystem !== '') && (rangeEWSSystem !== ewsSystem)) {
					ewsSystem = '';
				} else {
					ewsSystem = rangeEWSSystem; 
				}
				var actionMenuItem = {
					name: (index === 0 ? 'EarlyWarningScores' : ''),
					value: rangeObj.actionMenuCaption,
					statusColour: rangeObj.colour,
				};
				ewsRangeActionMenuItems.push(actionMenuItem);
			});
		
			var ewsSystemActionMenuItem = [];
			if (ewsSystem !== '') {
				ewsSystemActionMenuItem.push({
					name: 'EWS',
					value: ewsSystem	
				}); 
			}
		
			return ewsSystemActionMenuItem.concat(ewsRangeActionMenuItems); 
		};
		
		// returns additional action menu items for the given graphItem
		var getExtraActionMenuItems = function(graphItem) {
			var ewsActionMenuItems = [];
			if (angular.isDefined(graphItem.ewsRanges)) {
				ewsActionMenuItems = getEWSActionMenuItems(graphItem);
			}
			return ewsActionMenuItems;
		};
		
		return getExtraActionMenuItems;
	};
	
	this.getActionMenuClickHandler = function() {
		// handle click events for action menu links: toggling EWS and reference ranges
		var actionMenuClickHandler = function(name, item) {
			if (name === 'ToggleEWS') {
				item.showEWSRanges = !item.showEWSRanges;
			} else if (name === 'ToggleRefRanges') {
				item.showReferenceLines = !item.showReferenceLines;
			}
		};
		
		return actionMenuClickHandler;
	};
});
